import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import {
  FetchResponse,
  UserCode,
  UserCodeData,
  UserCodePostData
} from './types.ts'

const getCodes = async () => {
  try {
    const response = await httpClient.get<UserCode[]>(
      '/api/user_assignment_codes/'
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred' + String(error))
  }
}

const getCodeDetails = async (id: number) => {
  try {
    const response = await httpClient.get<UserCode>(
      `/api/user_assignment_codes/${id}`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred' + String(error))
  }
}

const createCode = async (codeData: UserCodePostData) => {
  try {
    const response = await httpClient.post(
      '/api/user_assignment_codes/',
      codeData
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const updateCode = async (
  userCodeID: number,
  codeData: UserCodePostData | UserCodeData
) => {
  try {
    const response = await httpClient.put(
      `/api/user_assignment_codes/${userCodeID}/`,
      codeData
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const deleteCode = async (codeID: number) => {
  try {
    const response = await httpClient.delete(
      `/api/user_assignment_codes/${codeID}/`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const getSurveyReport = async <T>(codeID: number, surveyTemplateID: number) => {

  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(
      `/api/user_assignment_codes/${codeID}/get_survey_report/?survey_template_id=${surveyTemplateID}`,
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const userAssignmentCodes = {
  getCodes,
  getCodeDetails,
  createCode,
  updateCode,
  deleteCode,
  getSurveyReport
}
